import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SearchFooter.module.less';

function SearchFooter({ children }) {
  return <div className={clsx('page-width', styles.root)}>{children}</div>;
}

SearchFooter.propTypes = {
  children: PropTypes.node,
};

export default SearchFooter;
